import script from "./create_coupon.vue?vue&type=script&setup=true&lang=js"
export * from "./create_coupon.vue?vue&type=script&setup=true&lang=js"

import "./create_coupon.vue?vue&type=style&index=0&id=359f5c1d&lang=css"

const __exports__ = script;

export default __exports__